import Axios from '@/plugins/axios'
import { onlineUrl,payUrl,homeUrl } from '@/utils/config';
const newPayUrl = payUrl + '/pay'
export function getMyQuoteListApi(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/partner/rfq/quote/list`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/list`,
    method: 'POST',
    data: params,
    noMessage:true
  }
  return Axios(config);
}
export function getMyQuoteStatusNumberApi(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/partner/rfq/quote/list-num`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/list-num`,
    method: 'POST',
    data: params,
    noMessage:true
  }
  return Axios(config);
}
export function getRfqQuoteInfoApi(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/partner/rfq/quote/info`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/info`,
    method: 'POST',
    data: params,
    noMessage:true
  }
  return Axios(config);
}
export function getMyQuoteDetailApi(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/partner/rfq/quote/info`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/info`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}
export function getInitQuoteInfoApi(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/partner/rfq/quote/init-create`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/init-create`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}
export function saveQuoteOrderApi(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/partner/rfq/quote/create`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/create`,
    method: 'POST',
    data: params,
    noMessage:true
  }
  return Axios(config);
}
export function withdrawQuoteOrderApi(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/partner/rfq/quote/withdraw`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/withdraw`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}
export function getContactInfoApi(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/partner/rfq/quote/contact-info`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/contact-info`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}
export function getCheckQuoteApi(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/partner/rfq/quote/completeness`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/contact-info`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}
export function applyTwoNDAApi(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/partner/rfq/quote/apply-two-nda`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/contact-info`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}
export function getDraftListApi(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/partner/rfq/quote/draft/list`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/contact-info`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}
//非甄云获取联系方式接口
export function contactInfApi(params) {
  const config = {
    url: `${ onlineUrl }/mk-leads/common/user/click/contact-info`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/contact-info`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}

// 合作方授权签约
export function getPartnerAuthSignApi(params) {
  const config = {
    url: `${ newPayUrl }/my-bank/bank/partner-auth-sign`,
    // url: `/need/mk-rfq-api/partner/rfq/quote/contact-info`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}

/**
 * 获取用户信息
 */
export function getsalesinfo() {
  const config = {
    url: `${onlineUrl}/mk-leads/leads/sales-info`,
    method: "GET"
  };
  return Axios(config);
}


/** 获取询盘列表 */
export function getRfq () {
  const config = {
    url: `${homeUrl}/mk-rfq-api/partner/rfq/latest-needs`,
    method: "GET",
  };
  return Axios(config);
}